import type { PropsOf } from '@emotion/react';
import { Modal } from '@innovationdepartment/proxima-ui';
import DisconnectIntegrationModalView from './DisconnectIntegrationModal.View';

export type DisconnectIntegrationModalProps = {
  open: boolean;
} & PropsOf<typeof DisconnectIntegrationModalView>;

const DisconnectIntegrationModal = ({ open, confirm, close }: DisconnectIntegrationModalProps) => (
  <Modal noPadding={false} open={open} title="Disconnect account?">
    <DisconnectIntegrationModalView confirm={confirm} close={close} />
  </Modal>
);
export default DisconnectIntegrationModal;
